import { render, staticRenderFns } from "./VeButtonBlockSettings.vue?vue&type=template&id=0e59b229"
import script from "./VeButtonBlockSettings.vue?vue&type=script&lang=js"
export * from "./VeButtonBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports